<template id="myiframe">
    <div style="height:100%">
        <iframe v-if="src" :src='src' frameborder="0" width="100%" :height="th+'px'"></iframe>
    </div>
</template>

<script>
    import {getToken} from "@/utils/auth"
    export default {
        name: "Role",
        data(){
            return{
                src:'',
                th:0
            }
        },
        components:{
            // Edit,
        },
        
        created(){
            this.init();
            this.getHight();
            window.addEventListener('resize', this.getHight);
        },
        destroyed() {
            window.removeEventListener('resize', this.getHight);
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val+191;
            },
            $route(){
                this.init()
            },
        },
        methods:{
            /**
             * plateform:平台类型
             * 平台和平台Code不能有交集
             * 若只想查某个政府的数据，请不要传这个政府所属平台
             * 
             * govCode:设备所属机构/政府Code
             * 由于设备有的存储的是政府下角色的Code
             * 所以配置时请多配置个此角色的Code，例如：政府下机构Code,政府下商家Code等
             * 
             * isParent:是否是上级角色判断是否是只读模式
             */
            init:function(){
                let src=this.$deviceAdm+'#/deviceLink/dhCamera?isParent=true'
                var govermentCodeList=[]
                var plateformList=[]
                var token =JSON.parse(getToken());
                if(token.visualAccountComadmCommunityCodeList[0]=="getAll"){
                    plateformList.push("community")
                }else{
                    token.visualAccountComadmCommunityCodeList.forEach(ele=>{
                        govermentCodeList.push(ele);
                    })
                }
                if(token.visualAccountHomeGovernmentCodeList[0]=="getAll"){
                    plateformList.push("home")
                }else{
                    token.visualAccountHomeGovernmentCodeList.forEach(ele=>{
                        govermentCodeList.push(ele);
                    })
                }
                if(token.visualAccountInsGovernmentCodeList[0]=="getAll"){
                    plateformList.push("institution")
                }else{
                    token.visualAccountInsGovernmentCodeList.forEach(ele=>{
                        govermentCodeList.push(ele);
                    })
                }
                if(token.visualAccountShopGovernmentCodeList[0]=="getAll"){
                    plateformList.push("shop")
                }else{
                    token.visualAccountShopGovernmentCodeList.forEach(ele=>{
                        govermentCodeList.push(ele);
                    })
                }
                if(plateformList.length>0){
                    src+="&plateform="+plateformList.join(",")
                }
                if(govermentCodeList.length>0){
                    src+="&govCode="+govermentCodeList.join(",")
                }
                console.log(src)
                this.src=src
            },
            getHight(){
                this.th=document.body.clientHeight-4;
            },
        }
    }
</script>